export default "__VITE_ASSET__DSjDYYac__"